{
  "name": "pnkl-frontend",
  "version": "16.1.84",
  "license": "MIT",
  "engines": {
    "node": ">=26 <27",
    "npm": ">=11 <12"
  },
  "sideEffects": false,
  "browser": {
    "net": false,
    "tls": false,
    "crypto": false,
    "https": false
  },
  "scripts": {
    "ng": "ng",
    "nx": "nx",
    "start-custom:poems": "nx serve platform-web-app --configuration custom",
    "start-local:poems": "nx serve platform-web-app --configuration local",
    "start-dev:poems": "nx serve platform-web-app --configuration development",
    "start-stage:poems": "nx serve platform-web-app --configuration staging",
    "start-prod:poems": "nx serve platform-web-app --configuration production",
    "build-dev:poems": "nx build platform-web-app --configuration development",
    "build-stage:poems": "nx build platform-web-app --configuration staging",
    "build-prod:poems": "nx build platform-web-app --configuration production",
    "start-custom:crm": "nx serve crm-app --configuration custom",
    "start-local:crm": "nx serve crm-app --configuration local",
    "start-dev:crm": "nx serve crm-app --configuration development",
    "start-prod:crm": "nx serve crm-app --configuration production",
    "build-dev:crm": "nx build crm-app --configuration development",
    "build-prod:crm": "nx build crm-app --configuration production",
    "e2e:crm": "nx e2e crm-app-e2e",
    "e2e-ui:crm": "nx e2e-ui crm-app-e2e",
    "e2e:crm:local": "CRM_E2E_BASE_URL=https://localhost:4200 nx e2e crm-app-e2e",
    "e2e-ui:crm:local": "CRM_E2E_BASE_URL=https://localhost:4200 nx e2e-ui crm-app-e2e",
    "serve:crm:e2e": "nx serve crm-app --configuration e2e",
    "lighthouse:crm": "node tools/lighthouse/run.mjs crm-app --auth",
    "lighthouse:poems": "node tools/lighthouse/run.mjs platform-web-app --auth",
    "start-dev:portal": "nx serve investor-portal --configuration development",
    "start-dev-to-prod:portal": "nx serve investor-portal --configuration dev-to-prod",
    "start-prod:portal": "nx serve investor-portal --configuration production",
    "start-local:portal": "nx serve investor-portal --configuration local",
    "build-dev:portal": "nx build investor-portal --configuration development",
    "build-prod:portal": "nx build investor-portal --configuration production",
    "start-dev:dedicated-portal": "nx serve dedicated-investor-portal --configuration development",
    "start-dev-to-prod:dedicated-portal": "nx serve dedicated-investor-portal --configuration dev-to-prod",
    "start-prod:dedicated-portal": "nx serve dedicated-investor-portal --configuration production",
    "start-local:dedicated-portal": "nx serve dedicated-investor-portal --configuration local",
    "build-dev:dedicated-portal": "nx build dedicated-investor-portal --configuration development",
    "build-prod:dedicated-portal": "nx build dedicated-investor-portal --configuration production",
    "start-dev:pdf-viewer": "nx serve crm-documents --configuration development",
    "start-prod:pdf-viewer": "nx serve crm-documents --configuration production",
    "build-dev:pdf-viewer": "nx build crm-documents --configuration development",
    "build-prod:pdf-viewer": "nx build crm-documents --configuration production",
    "start-local:auth": "nx serve authenticator --configuration local --port=4201 --ssl",
    "start-dev:auth": "nx serve authenticator --configuration development --port=4201 --ssl",
    "start-prod:auth": "nx serve authenticator --configuration production --port=4201 --ssl",
    "build-dev:auth": "nx build --skip-nx-cache authenticator --configuration development",
    "build-prod:auth": "nx build --skip-nx-cache authenticator --configuration production",
    "start-dev:crm-outlook-addin": "nx serve crm-outlook-addin --configuration development",
    "start-prod:crm-outlook-addin": "nx serve crm-outlook-addin --configuration production",
    "build-dev:crm-outlook-addin": "nx build crm-outlook-addin --configuration development",
    "build-prod:crm-outlook-addin": "nx build crm-outlook-addin --configuration production",
    "start-dev:outlook-watermark-addin": "nx serve outlook-watermark-addin --configuration development",
    "build-dev:outlook-watermark-addin": "nx build outlook-watermark-addin --configuration development",
    "build-prod:outlook-watermark-addin": "nx build outlook-watermark-addin --configuration production",
    "lint": "nx affected --target=lint --parallel --exclude pnkl-frontend",
    "lint:all": "nx run-many -t lint --exclude pnkl-frontend --quiet --skip-nx-cache",
    "test:all": "nx run-many -t test --skip-nx-cache",
    "test:pms": "nx run pms-domain:test",
    "affected:apps": "nx affected:apps",
    "eslint:poems": "nx run-many --target=lint --projects=platform-web-app --quiet",
    "eslint:crm": "nx run-many --target=lint --projects=crm-app --quiet",
    "eslint:portal": "nx run-many --target=lint --projects=investor-portal --quiet",
    "eslint:dedicated-portal": "nx run-many --target=lint --projects=dedicated-investor-portal --quiet",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "nx migrate nx@latest",
    "update:check": "nx migrate nx@latest --interactive=false --dry-run",
    "workspace-schematic": "nx workspace-schematic",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "reset": "nx reset",
    "fix-migrations": "nx migrate --run-migrations",
    "nx-migrate": "nx migrate latest",
    "npm-ci": "npm ci",
    "prepare": "husky",
    "storybook:prime": "nx run shared-ui-prime:storybook",
    "proto:generate": "buf generate --template libs/grpc/buf.gen.yaml",
    "icons:generate": "node tools/generators/generate-icons.mjs"
  },
  "private": true,
  "dependencies": {
    "@amplitude/analytics-browser": "^2.40.0",
    "@angular/cdk": "22.2.3",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/google-maps": "22.2.3",
    "@angular/platform-browser": "22.2.3",
    "@angular/router": "22.2.3",
    "@bufbuild/protobuf": "^2.15.0",
    "@connectrpc/connect": "^2.2.0",
    "@connectrpc/connect-web": "^2.2.0",
    "@growthbook/growthbook": "^1.8.0",
    "@ngrx-toolkit/core": "22.0.1",
    "@ngrx/operators": "22.0.0",
    "@ngrx/signals": "22.0.0",
    "@primeui/license-manager": "^1.0.0",
    "@primeuix/themes": "^3.0.0",
    "@tinymce/tinymce-angular": "^9.1.1",
    "ag-grid-angular": "36.1.0",
    "ag-grid-community": "36.1.0",
    "ag-grid-enterprise": "36.1.0",
    "angular-auth-oidc-client": "21.0.2",
    "angular-svg-round-progressbar": "^15.0.0",
    "chart.js": "^4.5.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "countries-and-timezones": "^3.8.0",
    "expr-eval-fork": "^3.0.3",
    "fast-deep-equal": "^3.1.3",
    "highcharts": "13.1.1",
    "highcharts-angular": "5.4.1",
    "lodash": "^4.17.21",
    "marked": "^18.0.2",
    "moment": "^2.30.1",
    "ng-qrcode": "22.0.0",
    "ngx-clipboard": "^16.0.0",
    "ngx-extended-pdf-viewer": "29.0.1",
    "ngx-timeago": "^4.1.0",
    "optiscroll": "^3.2.1",
    "primeicons": "^8.0.0",
    "primeng": "22.1.0",
    "primereact": "^10.9.8",
    "quill": "^2.0.3",
    "react": "^19.2.8",
    "react-dom": "^19.2.8",
    "rxjs": "~7.8.2",
    "tinymce": "^8.10.1",
    "tslib": "^2.8.1",
    "uuid": "^14.0.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.2.3",
    "@angular-devkit/core": "22.2.3",
    "@angular-devkit/schematics": "22.2.3",
    "@angular/build": "22.2.3",
    "@angular/cli": "22.2.3",
    "@angular/compiler-cli": "22.2.3",
    "@angular/language-service": "22.2.3",
    "@angular/platform-browser-dynamic": "22.2.3",
    "@bufbuild/buf": "^1.73.0",
    "@bufbuild/protoc-gen-es": "^2.15.0",
    "@chromatic-com/storybook": "^5.3.0",
    "@eslint/js": "^10.0.1",
    "@nx/angular": "23.3.0",
    "@nx/eslint": "23.3.0",
    "@nx/eslint-plugin": "23.3.0",
    "@nx/js": "23.3.0",
    "@nx/web": "23.3.0",
    "@playwright/test": "^1.61.1",
    "@schematics/angular": "22.1.8",
    "@storybook/addon-docs": "10.6.3",
    "@storybook/angular": "10.6.3",
    "@swc/helpers": "~0.5.18",
    "@tailwindcss/postcss": "^4.2.2",
    "@types/google.maps": "^3.58.1",
    "@types/lodash": "^4.17.20",
    "@types/node": "26.4.1",
    "@types/office-js": "^1.0.586",
    "@types/react": "^19.2.18",
    "@types/react-dom": "^19.2.4",
    "@typescript-eslint/utils": "^8.58.0",
    "angular-eslint": "22.1.0",
    "esbuild": "^0.28.1",
    "eslint": "^10.7.0",
    "husky": "^9.1.7",
    "lint-staged": "^17.3.0",
    "nx": "23.3.0",
    "postcss": "^8.5.28",
    "prettier": "^3.6.2",
    "prettier-plugin-organize-imports": "^4.1.0",
    "prettier-plugin-sort-json": "^4.1.1",
    "sass": "1.102.0",
    "storybook": "10.6.3",
    "svgo": "3.3.5",
    "tailwindcss": "^4.2.2",
    "tailwindcss-primeui": "^0.6.1",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.64.0",
    "vitest": "^4.1.12"
  },
  "nx": {
    "targets": {}
  },
  "overrides": {
    "undici": "^7.29.1",
    "sockjs": {
      "uuid": "^11.1.1"
    }
  },
  "allowScripts": {
    "@bufbuild/buf@1.73.0": true,
    "@parcel/watcher@2.6.0": true,
    "esbuild@0.28.2": true,
    "fsevents@2.3.3": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "nx@23.2.1": true
  }
}
